// Imports
import React from "react"
import { useSectionClientsData } from "@queries"
import { Section } from "@layout"

export const Clients = () => {
  const { logos } = useSectionClientsData()

  return (
    <Section name="clients">
      <div className="clients-container">
        <div className="clients-logos">
          {logos.map((logo) => {
            return (
              <div key={logo.url} className="clients-logos__item">
                <img src={logo.url} alt={logo.url} />
              </div>
            )
          })}
        </div>
      </div>
    </Section>
  )
}
